import React from 'react'
import PropTypes from 'prop-types'
import { Box, Container } from '@chakra-ui/react'

const VideoLayoutOne = ({ data, theme }) => {
  function constructURL () {
    if (data.type === 'Youtube') {
      const isSharedUrl = data && data.url && data.url.indexOf('youtu.be') !== -1

      if (isSharedUrl) {
        const videoId = data && data.url && data.url.split('/')[3]
        const url = `https://www.youtube.com/embed/${videoId}`

        return url
      } else {
        const url = `https://www.youtube.com/embed/${data.url.split('=')[1]}`

        return url
      }
    }

    if (data.type === 'Vimeo') {
      const url = `https://player.vimeo.com/video/${data.url.split('/')[3]}`

      return url
    }
  }

  return (
    <Box
      width='full'
      px={[2, 4, 8, 16]}
      bg={theme.backgroundColor}
      className='video-section'
    >
      <Box bg={theme.backgroundColor} py={8} px={[4, 4, 0, 0]}>
        <Container maxW='container.lg' mx='auto' px={0}>
          <Box
            as='h2'
            color={theme.sectionTitleColor}
            fontSize='sectionTitle'
            fontWeight='heading'
            fontFamily='heading'
            mb={4}
          >
            {data.title}
          </Box>
          <Box
            boxShadow='site'
            rounded='site'
            as='iframe'
            src={constructURL()}
            height={`${data.height}px`}
            width='full'
            frameBorder='0'
            allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
            mx='auto'
            allowfullscreen
          />
        </Container>
      </Box>
    </Box>
  )
}

VideoLayoutOne.propTypes = {
  data: PropTypes.object,
  theme: PropTypes.object
}

export default VideoLayoutOne
